<template>
  <div class="recommend-list">

    <!-- <van-search 
      placeholder="请输入姓名/职位/订单ID等" 
      v-model="keyword" 
      shape="round"
      left-icon=""
      @search="onSearch">
    </van-search> -->

		<van-list
      v-if="(list && list.length) || loading"
		  v-model="loading"
		  :finished="finished"
		  finished-text="没有更多了"
		  @load="onLoad"
		>
		  <ai-recommend-item v-for="item in list" :candidate="item" from="ai"></ai-recommend-item>
		</van-list>
    <no-data v-else></no-data>
  </div>
</template>

<script>

import AiRecommendItem from '@/components/order/list'
import {getAiCandidateList, listHomologous} from '@/api/aiMatch'
import NoData from "@/components/noData";

export default {
  name: "recommendList",
  components: {
  	AiRecommendItem, NoData
  },
  data(){
  	return {
  		loading: false,
  		finished: false,
  		list: [],
      keyword: this.$route.query.keyword||'',
      pageNo: 1,
      pageSize: 10
  	}
  },
  methods: {
  	onLoad(){
      this.loading = true;
      let params = {pageNo:this.pageNo,pageSize:this.pageSize, ...this.$route.query};

      getAiCandidateList(params).then(res=>{
        if(res.data&&res.data.candidates){
          let ids = [];
          res.data.candidates.forEach(item=>{
            item.unReadCount = 0;
            ids.push(item.candidateId);
          })

          if(ids.length){
            this.getListHomologous(ids);
          }

          this.list = this.list.concat(res.data.candidates||[]);
          this.pageNo++;
          if(res.data.candidates.length<this.pageSize)
            this.finished = true;
        }else{
          this.finished = true;
        }
        
      }).catch(err=>{}).finally(()=>{this.loading = false;});
    },
    getListHomologous(ids){
      listHomologous({sourceIds: ids.join(','), type: 2}).then(res=>{
        if(res.data){
          this.list.forEach(item=>{
            if(res.data[item.candidateId]){
              item.unReadCount = res.data[item.candidateId];
            }
          })
        }
      })
    },
    onSearch(){
      let params = {...this.$route.query};
      params.keyword = this.keyword;
      if(!this.keyword)
        delete params.keyword;

      this.$router.replace({name: this.$route.name, query: {...params}});
    }
  },
  watch: {
    $route(n,o){
      this.list = [];
      this.pageNo = 1;
      this.finished = false;
      this.onLoad();
    }
  },
  created() {
    this.onLoad();
  }
};
</script>

<style lang="scss" scoped>
  .van-list{
    background: #f5f5f5;
  }
</style>
